import { render, staticRenderFns } from "./customTemplate.vue?vue&type=template&id=5451d539&scoped=true&"
import script from "./customTemplate.vue?vue&type=script&lang=js&"
export * from "./customTemplate.vue?vue&type=script&lang=js&"
import style0 from "./customTemplate.vue?vue&type=style&index=0&id=5451d539&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451d539",
  null
  
)

export default component.exports